import React from 'react';
import { BellRing } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/Button';

interface AlertButtonProps {
  onClick?: () => void;
  label?: string;
  disabled?: boolean;
  className?: string;
  variant?: 'default' | 'compact';
}

const AlertButton: React.FC<AlertButtonProps> = ({
  onClick,
  label = "Criar um alerta",
  disabled = false,
  className,
  variant = 'default'
}) => {
  if (variant === 'compact') {
    return (
      <Button
        variant="primary"
        onClick={onClick}
        disabled={disabled}
        className={cn(
          "flex h-10 px-6 lg:px-8 justify-center items-center gap-2 rounded-full",
          className
        )}
      >
        <BellRing className="w-5 h-5" />
        <span className="text-sm font-normal">
          {label}
        </span>
      </Button>
    );
  }

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "flex h-12 px-6 lg:px-8 justify-center items-center gap-2 w-full sm:w-auto rounded-full bg-neutral-black transition-colors",
        disabled
          ? "opacity-50 cursor-not-allowed"
          : "hover:bg-neutral-black/90 active:bg-neutral-black/80",
        className
      )}
    >
      <BellRing className="w-6 h-6 text-white" />
      <span className="text-base font-normal text-white whitespace-nowrap">
        {label}
      </span>
    </button>
  );
};

export { AlertButton, type AlertButtonProps };
export default AlertButton;